import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInventoryLocations } from '../../actions/inventory';
import { InventoryLocationType } from '../../pages/Inventory/InventoryController';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA } from '../../types/inventory';
import { useFormContext } from 'react-hook-form';

export default function Site({ name, label, onChange = () => { }, org_id, prefill = [], addNew = false, className = 'w-full', required = false, disabled = false, filter = [] }) {
    const dispatch = useDispatch();
    const inventoryLocationsDropdown = useSelector((state) => state.inventory.inventoryLocationsDropdown);
    const isInventoryDropdownLocationsLoading = useSelector((state) => state.loading.isInventoryDropdownLocationsLoading);
    const methods = useFormContext();


    const memoizedInventoryLocationsDropdown = useMemo(() => {
        const siteOptions = inventoryLocationsDropdown[InventoryLocationType.SITE] || [];
        let list = addNew ? [{ label: 'Add New Site', value: 'add-new-site' }, ...siteOptions] : siteOptions;
        if (filter.length > 0) {
            list = list.filter((item) => !filter.includes(item.value))
        }
        return list;
    }, [inventoryLocationsDropdown, addNew, filter]);

    const getSiteList = ({ limit = 50, page = 1, query = '', org_id }) => {
        dispatch(getInventoryLocations({ limit, page, query, dropdown: true, type: InventoryLocationType.SITE, payload: { org_id } }));
    };

    const debouncedSiteSearchSearch = useCallback(debounce(getSiteList), []);

    useEffect(() => {
        if (org_id) {
            getSiteList({ limit: 100, page: 1, query: '', org_id });
        }
    }, [org_id]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA, payload: InventoryLocationType.SITE });
        }
    }, [dispatch]);

    useEffect(() => {
        if (prefill && prefill.length > 0 && memoizedInventoryLocationsDropdown && memoizedInventoryLocationsDropdown.length > 0) {
            const find = memoizedInventoryLocationsDropdown.find((option) => prefill.includes(option.id));
            if (find) {
                methods.setValue(name, find);
            }
        }
    }, [prefill, memoizedInventoryLocationsDropdown]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            options={memoizedInventoryLocationsDropdown}
            isLoading={isInventoryDropdownLocationsLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    debouncedSiteSearchSearch({ query: event, org_id })
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value, { data: event })
            }}
            required={required}
            readOnly={disabled}
        />
    )
}